// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"411":"61a73de6","512":"48ba56e5","652":"641f6fb1","659":"ab4c6644","706":"3d842d59","709":"e2fbe379","766":"6435e03b","954":"4512dc6a"}[chunkId] + ".chunk.css";
};